<!--
 * @Author       : wenquan
 * @desc         : 智慧就业-指导网
 * @Date         : 2020-09-14 10:42:02
 * @LastEditTime : 2020-11-23 15:25:37
 * @LastEditors  : wenquan
 * @FilePath     : \zhkt-4.2d:\workHand\201912021005\teaching_QualityService\src\base\ht-loading.vue
-->
<template>
    <div :class="[dialog?'ht-loading':'ht-loading2']"
         v-if="loading"
         ref="ht-loading">
        <div class="ht-loading-shade"></div>
        <div class="ht-loading-content">
            <img src="@/assets/images/loading-srcl.gif" />
            <label v-if="name">{{name}}...</label>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        limi: {
            type: Boolean,
            default: false
        },
        dialog: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {}
    },
    mounted () {
    },
    methods: {
    },
    watch: {
        loading (val) {
            if (val && this.limi) {
                this.$nextTick(() => {
                    var ev = this.$refs['ht-loading']
                    ev.parentElement.style.position = 'relative'
                    ev.style.position = 'absolute'
                    ev.children[0].style.position = 'absolute'
                })
            }
        }
    }
}
</script>
<style scoped  lang="stylus" rel='stylesheet/stylus'>
@import '~common/stylus/variable'
.ht-loading {
    position: fixed
    top: 0
    bottom: 0
    left: 50%
    overflow: auto
    margin: 0
    z-index: 5000
    fontSize(0.2rem)
    overflow-x: hidden
    text-align: center
    transform: translateX(-50%)
    .ht-loading-shade {
        position: fixed
        left: 0
        top: 0
        width: 100%
        height: 100%
        opacity: 0.5
        background: #000
        z-index: 5001
        border-radius: 5px
    }
    .ht-loading-content {
        top: 50%
        transform: translateY(-50%)
        text-align: left
        position: relative
        box-sizing: border-box
        z-index: 5003
        transition: all 0.3s
        opacity: 1
        display: inline-block
        text-align: center
        padding: 5px
        label {
            display: block
            margin-top: 0.1rem
            color: #fff
            fontSize(0.16rem)
        }
        img {
            width: 0.5rem
        }
    }
}
.ht-loading2 {
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    overflow: auto
    margin: 0
    z-index: 5000
    fontSize(0.2rem)
    overflow-x: hidden
    text-align: center
    .ht-loading-shade {
        position: fixed
        left: 0
        top: 0
        width: 100%
        height: 100%
        opacity: 0.5
        background: #000
        z-index: 5001
    }
    .ht-loading-content {
        top: 50%
        transform: translateY(-50%)
        text-align: left
        position: relative
        box-sizing: border-box
        z-index: 5003
        transition: all 0.3s
        opacity: 1
        display: inline-block
        text-align: center
        label {
            display: block
            margin-top: 0.1rem
            color: #fff
            fontSize(0.16rem)
        }
        img {
            width: 0.5rem
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/base/ht-loading.vue